import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
const toneFill = {
    brand: 'bg-[var(--color-brand-bg)]',
    neutral: 'bg-[var(--color-state-neutral-solid)]',
    success: 'bg-[var(--color-state-success-solid)]',
    warning: 'bg-[var(--color-state-warning-solid)]',
    danger: 'bg-[var(--color-state-danger-solid)]',
    info: 'bg-[var(--color-state-info-solid)]',
};
/**
 * A single-value horizontal bar (day-trend rows, usage meters, …). The fill
 * width is the one genuinely per-instance number a stylesheet compiled ahead
 * of time cannot enumerate — same category of unavoidable dynamism as
 * ChannelBadge/RoleBadge's per-kind CSS custom properties — so it is the
 * ONLY place in the kit that reaches for inline `style`, encapsulated here
 * instead of hand-rolled at each call site.
 */
export const Meter = React.forwardRef(({ value, label, className, trackClassName, tone = 'brand', fillClassName, ...props }, ref) => {
    const pct = Math.max(0, Math.min(100, value));
    // Decorative by default (role="presentation") — most call sites already
    // render the same value as adjacent text, so announcing it twice would be
    // redundant. Pass `label` to opt into an accessible `role="meter"`.
    return (_jsx("div", { ref: ref, role: label ? 'meter' : 'presentation', "aria-valuenow": label ? pct : undefined, "aria-valuemin": label ? 0 : undefined, "aria-valuemax": label ? 100 : undefined, "aria-label": label, className: cn('relative h-5 flex-1 overflow-hidden rounded-sm bg-[var(--color-surface-sunken)]', trackClassName, className), ...props, children: _jsx("div", { "data-tone": tone, className: cn('h-full rounded-sm', toneFill[tone], fillClassName), style: { width: `${pct}%` } }) }));
});
Meter.displayName = 'Meter';
//# sourceMappingURL=meter.js.map